
import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import { Project } from '@/model/Project';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import FormInput from '@/components/form/FormInput.vue';
import InviteButton from '@/active-components/customer-project/InviteButton.vue';
import { ProfileResponse } from '@/model/Profile';
import ProjectTable from '@/components/customer-project/ProjectTable.vue';
import FormSelector from '@/components/form/FormSelector.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

@Component({
    components: {
        FormInput,
        FormSelector,
        InviteButton,
        ProjectTable,
        ConfirmationModal,
    },
    methods: {
        ...mapActions({
            getAllProjects: 'customerProjectStorage/getAllProjects',
            fetchProfile: 'profileStorage/fetchProfile',
        }),
    },
    computed: {
        ...mapGetters({
            projects: 'customerProjectStorage/getProjects',
            profile: 'profileStorage/getProfile',
        }),
    },
})
export default class CustomerProject extends mixins(ToastMixin) {
    loading = false;

    projects!: Project[];

    profile!: ProfileResponse | null;

    currentPage = 1;

    perPage = 8;

    get itemsForList(): Project[] {
        return this.projects?.slice(
            (this.currentPage - 1) * this.perPage,
            this.currentPage * this.perPage,
        );
    }

    shouldShowProject(project: Project): boolean {
        return (
            project.enabled ||
            (!project.enabled && project.id === this.profile?.projectId)
        );
    }

    fetchProfile!: () => Promise<void | ProfileResponse>;

    getAllProjects!: (onlyActives: boolean) => Promise<void>;

    mounted(): void {
        this.getAllProjects(false);
        this.fetchProfile();
    }

    showDetails(projectId: number): void {
        this.$router.push(`customer-projects/${projectId}`);
    }
}
